import { dragConstants } from '../_constants/drag.constants'

export const dragActions = {
  setDragOverTarget,
}

function setDragOverTarget(target) {
  return { type: dragConstants.SET_DRAG_OVER_TARGET, target }
}
